// Motivi della visita nutrizionale + domande adattive per ciascun motivo.
// Ogni motivo ha una lista di domande specifiche che vengono mostrate nel
// form di Nuova valutazione nutrizionale.

export const VISIT_MOTIVES = [
  {
    id: "perdita_peso",
    label: "Perdita di peso (dimagrimento)",
    questions: [
      { id: "target_time", label: "Tempi desiderati per il dimagrimento",
        placeholder: "Es. 5 kg in 6 mesi" },
      { id: "previous_attempts", label: "Tentativi precedenti / diete già seguite",
        placeholder: "Es. dieta iperproteica 2023, chetogenica 2022" },
      { id: "perceived_cause", label: "Motivo del sovrappeso percepito dal paziente",
        placeholder: "Es. sedentarietà, stress lavorativo, post-gravidanza" },
      { id: "physical_activity", label: "Attività fisica attuale",
        placeholder: "Es. camminata 30 min 3v/settimana" },
    ],
  },
  {
    id: "aumento_massa",
    label: "Aumento di peso / massa muscolare",
    questions: [
      { id: "target_mass", label: "Obiettivo di massa muscolare",
        placeholder: "Es. +3 kg magra in 6 mesi" },
      { id: "training_frequency", label: "Frequenza allenamento (giorni/settimana)",
        placeholder: "Es. 4 giorni/settimana" },
      { id: "sport_type", label: "Tipo di attività / sport",
        placeholder: "Es. palestra bodybuilding, calisthenics" },
      { id: "supplements", label: "Integratori attualmente assunti",
        placeholder: "Es. proteine whey, creatina, multivitaminico" },
    ],
  },
  {
    id: "gravidanza",
    label: "Alimentazione in gravidanza / allattamento",
    questions: [
      { id: "gestational_week", label: "Settimana gestazionale / mese di allattamento",
        placeholder: "Es. 24° settimana" },
      { id: "high_risk", label: "Gravidanza a rischio?",
        placeholder: "Es. no / diabete gestazionale / ipertensione gestazionale" },
      { id: "supplements", label: "Integratori assunti (acido folico, ferro, vit. D)",
        placeholder: "Es. acido folico 400 mcg, ferro 30 mg" },
      { id: "weight_change", label: "Variazione ponderale in gravidanza",
        placeholder: "Es. +8 kg da inizio gravidanza" },
    ],
  },
  {
    id: "pediatrica",
    label: "Alimentazione pediatrica",
    questions: [
      { id: "child_age", label: "Età del bambino",
        placeholder: "Es. 8 anni" },
      { id: "growth_curve", label: "Andamento curva di crescita",
        placeholder: "Es. peso 90° percentile, altezza 50°" },
      { id: "appetite", label: "Appetito / preferenze alimentari",
        placeholder: "Es. buon appetito, ama carboidrati, rifiuta verdure" },
      { id: "food_refusal", label: "Cibi rifiutati / neofobia",
        placeholder: "Es. rifiuta verdure e legumi" },
    ],
  },
  {
    id: "menopausa",
    label: "Alimentazione in menopausa",
    questions: [
      { id: "years_since", label: "Da quanto tempo in menopausa",
        placeholder: "Es. 3 anni" },
      { id: "symptoms", label: "Sintomi principali",
        placeholder: "Es. vampate, ritenzione idrica, aumento ponderale" },
      { id: "weight_variation", label: "Variazione ponderale recente",
        placeholder: "Es. +5 kg in 2 anni" },
      { id: "hormone_therapy", label: "Terapia ormonale sostitutiva",
        placeholder: "Es. no / si (specificare)" },
    ],
  },
  {
    id: "patologia",
    label: "Alimentazione per patologia (diabete, dislipidemia, ipertensione, tiroide)",
    questions: [
      { id: "condition", label: "Patologia principale",
        placeholder: "Es. diabete tipo 2, ipercolesterolemia, ipertensione, ipotiroidismo" },
      { id: "current_therapy", label: "Terapia in corso",
        placeholder: "Es. metformina 1000 mg × 2/die, statina" },
      { id: "recent_labs", label: "Valori ematici recenti",
        placeholder: "Es. glicemia 118, HbA1c 6.4, LDL 145" },
      { id: "compliance", label: "Aderenza a diete precedenti",
        placeholder: "Es. buona / difficoltà con le restrizioni" },
    ],
  },
  {
    id: "intolleranze",
    label: "Intolleranze / allergie alimentari",
    questions: [
      { id: "type", label: "Tipo di intolleranza / allergia",
        placeholder: "Es. lattosio, glutine, nichel, istamina" },
      { id: "test_performed", label: "Test diagnostici effettuati",
        placeholder: "Es. breath test lattosio positivo, IgE latte" },
      { id: "symptoms", label: "Sintomi principali",
        placeholder: "Es. gonfiore, diarrea, orticaria, prurito" },
      { id: "trigger_foods", label: "Alimenti che scatenano sintomi",
        placeholder: "Es. latticini freschi, glutine, cioccolato" },
    ],
  },
  {
    id: "gastrointestinali",
    label: "Disturbi gastrointestinali (colon irritabile, gastrite, reflusso)",
    questions: [
      { id: "condition", label: "Disturbo specifico",
        placeholder: "Es. sindrome intestino irritabile, gastrite, MRGE, SIBO" },
      { id: "predominant_symptoms", label: "Sintomi predominanti",
        placeholder: "Es. gonfiore + stipsi alternata a diarrea" },
      { id: "trigger_foods", label: "Cibi che aggravano i sintomi",
        placeholder: "Es. legumi, cipolla, pomodoro, cibi grassi" },
      { id: "medications", label: "Farmaci gastro attualmente assunti",
        placeholder: "Es. IPP, procinetici, probiotici" },
    ],
  },
  {
    id: "sportiva",
    label: "Alimentazione sportiva / performance",
    questions: [
      { id: "sport", label: "Sport praticato",
        placeholder: "Es. ciclismo, running, calcio, crossfit" },
      { id: "training_hours", label: "Ore di allenamento a settimana",
        placeholder: "Es. 10 ore/settimana" },
      { id: "goal", label: "Obiettivo prestazionale",
        placeholder: "Es. maratona sub-4h, prep gara, dimagrimento sportivo" },
      { id: "supplements", label: "Integratori assunti",
        placeholder: "Es. maltodestrine, BCAA, creatina, sali minerali" },
    ],
  },
  {
    id: "veg",
    label: "Regime vegetariano / vegano",
    questions: [
      { id: "regime", label: "Regime seguito",
        placeholder: "Es. vegetariano LOVO, vegano stretto, pescetariano" },
      { id: "duration", label: "Da quanto tempo",
        placeholder: "Es. 3 anni" },
      { id: "motivation", label: "Motivazione principale",
        placeholder: "Es. etica, salute, ambientale" },
      { id: "supplements", label: "Integratori assunti (B12, ferro, omega-3)",
        placeholder: "Es. B12 sublinguale, ferro se anemia" },
    ],
  },
  {
    id: "eta_avanzata",
    label: "Alimentazione in età avanzata",
    questions: [
      { id: "age", label: "Età del paziente",
        placeholder: "Es. 78 anni" },
      { id: "autonomy", label: "Autonomia funzionale",
        placeholder: "Es. autosufficiente / assistito nei pasti" },
      { id: "chewing", label: "Difficoltà di masticazione / deglutizione",
        placeholder: "Es. no / protesi mobili, disfagia" },
      { id: "appetite", label: "Appetito e apporto idrico",
        placeholder: "Es. inappetenza, poca sete" },
    ],
  },
  {
    id: "benessere",
    label: "Benessere generale / educazione alimentare",
    questions: [
      { id: "motivation", label: "Motivazione principale",
        placeholder: "Es. migliorare stile di vita, prevenzione" },
      { id: "current_habits", label: "Abitudini alimentari attuali percepite",
        placeholder: "Es. salta la colazione, poche verdure, pasti fuori casa" },
      { id: "goals", label: "Obiettivi personali",
        placeholder: "Es. più energia, sonno regolare, prevenzione familiarità" },
    ],
  },
];

// Trova il motivo per id (usato per costruire la label finale nel PDF)
export const findMotive = (id) => VISIT_MOTIVES.find((m) => m.id === id);
